import { render } from "./ItemQuickPanel.vue?vue&type=template&id=e4ade116&scoped=true"
import script from "./ItemQuickPanel.vue?vue&type=script&lang=js"
export * from "./ItemQuickPanel.vue?vue&type=script&lang=js"

import "./ItemQuickPanel.vue?vue&type=style&index=0&id=e4ade116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ade116"]])

export default __exports__